<div class="card">
    <div class="card-header">
        <div class="row">
            <div class="col-lg-3 col-md-10 col-sm-11">
                <button class="btn btn-light btn-xs" (click)="expanded = !expanded">
                    @if (expanded) {
                        <span class="dripicons-chevron-up"></span>
                    }
                    @if (!expanded) {
                        <span class="dripicons-chevron-down"></span>
                    }
                </button>
                General
            </div>
            <div class="col-lg-7 col-md-10 col-sm-11">
                <div class="horizontal-steps mb-4" id="tooltip-container">
                    <div class="horizontal-steps-content">
                        @for (status of inventoryStatusesDisplayable; track status; let i = $index) {
                            <div class="step-item" id="inventoryStatus_{{status.id}}">
                                <span data-bs-container="#tooltip-container" data-bs-toggle="tooltip"
                                    data-bs-placement="bottom">{{status.name}}</span>
                            </div>
                        }
                    </div>
                    <div class="process-line" id="process-line" style="width: 0%;"></div>
                </div>
            </div>
            <div class="col-lg-2 col-md-10 col-sm-11">
                <button class="btn btn-success btn-sm float-right" (click)="saveInventory()"
                    [disabled]="information.invalid || !expanded || duplicateVINFound"
                    id="btn-save-generalInformation">Save</button>
                @if ((statusId!==6 || inventoryId !== 0) && calledFromSale == false) {
                    <button class="btn btn-info btn-sm float-right" data-target="#statusModal" data-toggle="modal"
                        id="btn-status-generalInformation">View Status</button>
                }
                @if (statusId===6) {
                    <button class="btn btn-warning btn-sm float-right" data-target="#restoreModal" data-toggle="modal"
                        [disabled]="!expanded" id="btn-restore-generalInformation">Restore</button>
                }
            </div>
        </div>
    </div>
    @if (expanded) {
    <div>
        <div class="card-body">
            <div class="row">
                <div class="col-md-4">
                    <div class="card border shadow-none">
                        <div class="card-header">Vehicle Information</div>
                        <div class="card-body">
                            <form class="text-dark" [formGroup]="information">
                                <div class="row">
                                    <div class="form-group col-md-12 col-sm-12">
                                        <label for="vinNumber">VIN</label>
                                        <div class="input-group">
                                            <input class="form-control form-control-sm" [ngClass]="{'duplicateVINFound' : duplicateVINFound}" type="text" id="vinNumber" required formControlName="vinNumber" autocomplete="off" />
                                            @if (vinNumber.value !== null) {
                                            <button class="btn btn-dark btn-sm ml-1" type="button"
                                                [disabled]="markAsDeleted===true"
                                                (click)="decodeVIN(stockNumber.value,vinNumber.value)">Decode</button>
                                            }
                                            @if (vinNumber.value === null) {
                                                <button class="btn btn-info btn-sm float-right ml-1" data-target="#scanVIN" data-toggle="modal" id="btn-save-generalInformation">Scan</button>
                                            }
                                        </div>
                                        @if (duplicateVINFound) {
                                            <div class="text-danger">VIN already exists in inventory! Saving disabled.</div>
                                        }
                                    </div>
                                    <div class="form-group col-md-6 col-sm-12">
                                        <label for="stockNumber">Stock Number</label>
                                        <input class="form-control form-control-sm" type="text" id="stockNumber" required formControlName="stockNumber" autocomplete="off" />
                                        @if (stockNumber.invalid) {
                                            <div class="text-danger">{{(stockNumber.errors && (stockNumber.errors.duplicateFound)) ? stockNumber.errors.duplicateFound : ''}}</div>
                                        }
                                    </div>
                                    <div class="form-group col-md-6 col-sm-12">
                                        <label for="certifyLevel">Certify</label>
                                        <select name="certifyLevel" id="certifyLevel" formControlName="certifyLevel"
                                            class="form-control form-control-sm">
                                            <option value=null></option>
                                            @for (certifyLevel of certifyLevels; track certifyLevel) {
                                            <option [value]="certifyLevel.code.toLowerCase()">
                                                {{certifyLevel.code | uppercase}} - {{certifyLevel.description}}</option>
                                            }
                                        </select>
                                    </div>
                                    <div class="form-group col-md-6 col-sm-12">
                                        <label for="modelYear">Year</label>
                                        <input class="form-control form-control-sm" type="text" id="modelYear"
                                            formControlName="modelYear" autocomplete="off">
                                    </div>
                                    <div class="form-group col-md-6 col-sm-12">
                                        <label for="make">Make</label>
                                        <input class="form-control form-control-sm" type="text" id="make"
                                            formControlName="make" autocomplete="off">
                                    </div>
                                    <div class="form-group col-md-6 col-sm-12">
                                        <label for="model">Model</label>
                                        <input class="form-control form-control-sm" type="text" id="model"
                                            formControlName="model" autocomplete="off">
                                    </div>
                                    <div class="form-group col-md-6 col-sm-12">
                                        <label for="miles">Miles</label>
                                        <count-input [id]="'miles'" [control]="information.get('miles')"></count-input>
                                    </div>
                                    <div class="form-group col-md-6 col-sm-12">
                                        <label for="odometer">Odometer</label>
                                        <select name="odometer" id="odometer" formControlName="odometer"
                                            class="form-control form-control-sm">
                                            @for (odometer of odometers; track odometer) {
                                                <option [value]="odometer.value.toLowerCase()">{{odometer.name}}</option>
                                            }
                                        </select>
                                    </div>
                                    <div class="form-group col-md-6 col-sm-12">
                                        <label for="exteriorColor">Exterior Color</label>
                                        <select name="exteriorColor" id="exteriorColor" formControlName="exteriorColor"
                                            class="form-control form-control-sm">
                                            <option value=""></option>
                                            @for (exteriorColor of colors; track exteriorColor) {
                                                <option [value]="exteriorColor.name">{{exteriorColor.name}}</option>
                                            }
                                        </select>
                                    </div>
                                    <div class="form-group col-md-6 col-sm-12">
                                        <label for="exteriorColorMinor">Exterior Minor Color</label>
                                        <select name="exteriorColorMinor" id="exteriorColorMinor"
                                            formControlName="exteriorColorMinor"
                                            class="form-control form-control-sm">
                                            <option value=""></option>
                                            @for (exteriorColorMinor of colors; track exteriorColorMinor) {
                                            <option [value]="exteriorColorMinor.name">
                                                {{exteriorColorMinor.name}}</option>
                                            }
                                        </select>
                                    </div>
                                    <div class="form-group col-md-6 col-sm-12">
                                        <label for="interiorColor">Interior Color</label>
                                        <select name="interiorColor" id="interiorColor" formControlName="interiorColor"
                                            class="form-control form-control-sm">
                                            <option value=""></option>
                                            @for (interiorColor of colors; track interiorColor) {
                                                <option [value]="interiorColor.name">{{interiorColor.name}}</option>
                                            }
                                        </select>
                                    </div>
                                    <div class="form-group col-md-6 col-sm-12">
                                        <label for="type">Type</label>
                                        <select name="type" id="type" formControlName="type"
                                            class="form-control form-control-sm">
                                            @for (type of vehicleTypes; track type) {
                                                <option [value]="type.name">{{type.name}}</option>
                                            }
                                        </select>
                                    </div>
                                    <div class="form-group col-md-6 col-sm-12">
                                        <label for="cylinders">Cylinders</label>
                                        <input class="form-control form-control-sm" type="text" id="cylinders"
                                            formControlName="cylinders" autocomplete="off">
                                    </div>
                                    <div class="form-group col-md-6 col-sm-12">
                                        <label for="engine">Engine</label>
                                        <input class="form-control form-control-sm" type="text" id="engine"
                                            formControlName="engine" autocomplete="off">
                                    </div>
                                    <div class="form-group col-md-6 col-sm-12">
                                        <label for="transmission">Transmission</label>
                                        <input class="form-control form-control-sm" type="text"
                                            id="transmission" formControlName="transmission" autocomplete="off">
                                    </div>
                                    <div class="form-group col-md-6 col-sm-12">
                                        <label for="driveline">Driveline</label>
                                        <input class="form-control form-control-sm" type="text" id="driveline"
                                            formControlName="driveline" autocomplete="off">
                                    </div>
                                    <div class="form-group col-md-6 col-sm-12">
                                        <label for="bodyStyle">Body</label>
                                        <input class="form-control form-control-sm" type="text" id="bodyStyle"
                                            formControlName="bodyStyle" autocomplete="off">
                                    </div>
                                    <div class="form-group col-md-6 col-sm-12">
                                        <label for="trimLevel">Trim Level</label>
                                        <input class="form-control form-control-sm" type="text" id="trimLevel"
                                            formControlName="trimLevel" autocomplete="off">
                                    </div>
                                    <div class="form-group col-md-6 col-sm-12">
                                        <label for="curbWeight">Curb Weight</label>
                                        <count-input [id]="'curbWeight'" [control]="information.get('curbWeight')" (change)="updateGVWR()"></count-input>
                                    </div>
                                    <div class="form-group col-md-6 col-sm-12">
                                        <label for="carryingWeight">Carrying Weight</label>
                                        <count-input [id]="'carryingWeight'" [control]="information.get('carryingWeight')" (change)="updateGVWR()"></count-input>
                                    </div>
                                    <div class="form-group col-md-6 col-sm-12">
                                        <label for="gvwr">GVWR</label>
                                        <count-input [id]="'gvwr'" [control]="information.get('gvwr')"></count-input>
                                    </div>
                                    <div class="form-group col-md-6 col-sm-12">
                                        <label for="tonnage">Tonnage</label>
                                        <select name="tonnage" id="tonnage" formControlName="tonnage"
                                            class="form-control form-control-sm">
                                            <option value="">N/A</option>
                                            <option value="¼">Quarter ton</option>
                                            <option value="½">Half ton</option>
                                            <option value="¾">Three-Quarter ton</option>
                                            <option value="1">One ton</option>
                                        </select>
                                    </div>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
                <!-- <div class="row"> -->
                <div class="col-md-4">
                    <div class="card border shadow-none">
                        <div class="card-header">Financials</div>
                        <div class="card-body">
                            <form class="text-dark" [formGroup]="information">
                                <div class="row">
                                    <div class="col-md-12">
                                        <table
                                            class="table table-responsive table-borderless table-sm text-right text-dark">
                                            <tr>
                                                <td>Purchase Cost</td>
                                                <td>
                                                    <currency-input [id]="'purchaseCost'" [control]="information.get('purchaseCost')"></currency-input>
                                                </td>
                                            </tr>
                                            <tr>
                                                <td>Recon. Cost</td>
                                                <td>+ {{reconCostTotal || 0 | currency}}
                                                </td>
                                            </tr>
                                            <tr>
                                                <td>Floor Plan Cost</td>
                                                <td>+ {{floorPlanCostTotal || 0 | currency}}
                                                </td>
                                            </tr>
                                            <tr class="border-top">
                                                <td>Total Cost</td>
                                                <td>{{costTotal | currency}}</td>
                                            </tr>
                                        </table>
                                    </div>
                                    <div class="col-md-12">
                                        <div class="row">
                                            <div class="form-group col-md-6 col-sm-12">
                                                <label for="writeDownCost">Write Down</label>
                                                <currency-input [id]="'writeDownCost'" [control]="information.get('writeDownCost')"></currency-input>
                                            </div>
                                            <div class="form-group col-md-6 col-sm-12">
                                                <label for="sellingPrice">Selling Price</label>
                                                <currency-input [id]="'sellingPrice'" [control]="information.get('sellingPrice')"></currency-input>
                                            </div>
                                            <div class="form-group col-md-6 col-sm-12">
                                                <label for="downPayment">Down Payment</label>
                                                <currency-input [id]="'downPayment'" [control]="information.get('downPayment')"></currency-input>
                                            </div>
                                            <div class="form-group col-md-6 col-sm-12">
                                                <label for="bookValue">Book Value</label>
                                                <currency-input [id]="'bookValue'" [control]="information.get('bookValue')"></currency-input>
                                            </div>
                                            <div class="form-group col-md-6 col-sm-12">
                                                <label for="paymentMethod">Payment Method</label>
                                                <select name="paymentMethod" id="paymentMethod"
                                                    formControlName="paymentMethod"
                                                    class="form-control form-control-sm">
                                                    @for (method of paymentMethods; track method) {
                                                    <option [value]="method.toLocaleLowerCase()">
                                                        {{method}}</option>
                                                    }
                                                </select>
                                            </div>
                                            <div class="form-group col-md-6 col-sm-12">
                                                <label for="datePurchased">Date Purchased</label>
                                                <input class="form-control form-control-sm" type="date"
                                                    id="datePurchased" formControlName="datePurchased"
                                                    autocomplete="off">
                                            </div>
                                            <div class="form-group col-md-6 col-sm-12">
                                                <label for="datePaid">Date Paid</label>
                                                <input class="form-control form-control-sm" type="date"
                                                    id="datePaid" formControlName="datePaid" autocomplete="off">
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </form>
                            <div class="card shadow-none m-0 p-0">
                                <div class="card-header">Helpful Links</div>
                                <div class="card-body">
                                    <ul>
                                        <!-- Recalls API: https://api.nhtsa.gov/recalls/recallsByVehicle?make=acura&model=rdx&modelYear=2012 -->
                                        <li> <a href="https://vinrcl.safercar.gov/vin" target="_blank"
                                                class="link-opacity-100-hover">Check for Recalls</a></li>
                                        <li> <a href="https://www.mytxcar.org/txcar_net/SecurityCheck.aspx"
                                                target="_blank" class="link-opacity-100-hover">Get Last Inspection
                                                Information</a></li>
                                    </ul>
                                </div>
                            </div>
                            @if (fileURL != null && fileURL != '') {
                            <div class="card shadow-none m-0 p-0">
                                <div class="card-img-top text-center">
                                    <img [src]="fileURL" alt="" id="img" class="rounded border border-dark img-fluid">
                                </div>
                            </div>
                            }
                        </div>
                    </div>
                </div>
                <div class="col-md-4">
                    <div class="card border shadow-none">
                        <div class="card-header">
                            Administrative
                            <div class="float-right font-weight-bold">Days Old: {{calculateDaysOld()}}</div>
                        </div>
                        <div class="card-body">
                            <form class="text-dark" [formGroup]="information">
                                <div class="row">
                                    <div class="form-group col-md-6 col-sm-12">
                                        <label for="lotId">Lot Location</label>
                                        <select id="lotId" formControlName="lotId"
                                            class="form-control form-control-sm">
                                            @for (lot of lots; track lot) {
                                            <option [value]="lot.id">
                                                {{lot.contact.name}}</option>
                                            }
                                        </select>
                                    </div>
                                    <div class="form-group col-md-6 col-sm-12">
                                        <label for="dateOnLot">Date on Lot</label>
                                        <input class="form-control form-control-sm" type="date" id="dateOnLot"
                                            formControlName="dateOnLot" autocomplete="off">
                                    </div>
                                    <div class="form-group col-md-12 col-sm-12">
                                        <contact-advanced-search type="inventorySource"
                                            [contactNameSaved]="information.get('source').value || ''"
                                            [contactIdSaved]="information.get('inventorySourceId').value"
                                            (setContactId)="setContactIdEvent($event)"></contact-advanced-search>
                                    </div>
                                    <div class="form-group col-md-6 col-sm-12">
                                        <label for="licensePlateNumber">License Plate Number</label>
                                        <input class="form-control form-control-sm" type="text"
                                            id="licensePlateNumber" formControlName="licensePlateNumber"
                                            autocomplete="off">
                                    </div>
                                    <div class="form-group col-md-6 col-sm-12">
                                        <label for="announcements">Announcements</label>
                                        <input class="form-control form-control-sm" type="text"
                                            id="announcements" formControlName="announcements" autocomplete="off">
                                    </div>
                                    <div class="form-group col-md-6 col-sm-12">
                                        <label for="airbagStatus">Airbag Status</label>
                                        <select name="airbagStatus" id="airbagStatus" formControlName="airbagStatus"
                                            class="form-control form-control-sm">
                                            @for (status of airbagStatuses; track status.value) {
                                                <option value="{{status.value.toLowerCase()}}">{{status.name}}</option>
                                            }
                                        </select>
                                    </div>
                                    <div class="form-group col-md-6 col-sm-12">
                                        <label for="keyNumberAssigned">Key Number</label>
                                        <input class="form-control form-control-sm" type="text"
                                            id="keyNumberAssigned" formControlName="keyNumberAssigned"
                                            autocomplete="off">
                                    </div>
                                    <div class="form-group col-md-6 col-sm-12">
                                        <label for="inspectionDate">Inspection Date</label>
                                        <input class="form-control form-control-sm" type="date"
                                            id="inspectionDate" formControlName="inspectionDate" autocomplete="off"
                                            (change)="updateInspectionExpires()">
                                    </div>
                                    <div class="form-group col-md-6 col-sm-12">
                                        <label for="inspectionExpires">Inspection Expires</label>
                                        <input class="form-control form-control-sm" type="date"
                                            id="inspectionExpires" formControlName="inspectionExpires"
                                            autocomplete="off">
                                    </div>
                                    <div class="form-group col-md-6 col-sm-12">
                                        <label for="inspectionDueDate">Inspection Due Date</label>
                                        <input class="form-control form-control-sm" type="date"
                                            id="inspectionDueDate" formControlName="inspectionDueDate"
                                            autocomplete="off">
                                    </div>
                                    <div class="form-group col-md-6 col-sm-12">
                                        <label for="titleLocation">Title Location</label>
                                        <input class="form-control form-control-sm" type="text"
                                            id="titleLocation" formControlName="titleLocation" autocomplete="off">
                                    </div>
                                    <div class="form-group col-md-6 col-sm-12">
                                        <label for="titleNumber">Title Number</label>
                                        <input class="form-control form-control-sm" type="text"
                                            id="titleNumber" formControlName="titleNumber" autocomplete="off">
                                    </div>
                                    <div class="form-group col-md-6 col-sm-12">
                                        <label for="titleCondition">Title Condition</label>
                                        <select name="titleCondition" id="titleCondition"
                                            formControlName="titleCondition"
                                            class="form-control form-control-sm">
                                            @for (titleCondition of titleConditions; track titleCondition) {
                                            <option [value]="titleCondition.value">
                                                {{titleCondition.name}}</option>
                                            }
                                        </select>
                                    </div>
                                    <div class="form-group col-md-6 col-sm-12">
                                        <label for="dateTitleReceived">Title Received Date</label>
                                        <input class="form-control form-control-sm" type="date"
                                            id="dateTitleReceived" formControlName="dateTitleReceived"
                                            autocomplete="off">
                                    </div>
                                    <div class="form-group col-md-6 col-sm-12">
                                        <label for="dateTitleDeliveredCustomer">Title Delivery Date</label>
                                        <input class="form-control form-control-sm" type="date"
                                            id="dateTitleDeliveredCustomer" formControlName="dateTitleDeliveredCustomer"
                                            autocomplete="off">
                                    </div>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
                <!-- </div> -->
            </div>
        </div>
        <div class="card-footer">
            @if (featuresExist) {
                <button class="btn btn-primary btn-sm" data-toggle="modal"
                    data-target="#vehicleSpecifications">{{words[language][ 'vehicleSpecifications' ] }}</button>
            }
            @if (deletable && inventoryId !== 0) {
                <button class="btn btn-danger btn-sm float-right" data-target="#deleteModal" data-toggle="modal"
                    [disabled]="!expanded" id="btn-delete-generalInformation">Delete</button>
            }
        </div>
    </div>
    }
</div>

<!-- modals -->
<!-- Feature List modal -->
<div class="modal fade" id="vehicleSpecifications" data-backdrop="static" tabindex="-1" role="dialog"
    aria-labelledby="mySmallModalLabel">
    <div class="modal-dialog modal-full-width modal-dialog-centered modal-dialog-scrollable">
        <div class="modal-content">
            <div class="modal-header">
                <h5>{{ words[language][ 'vehicleSpecifications' ]}}</h5>
                <button type="button" class="close" data-dismiss="modal">×</button>
            </div>
            <div class="modal-body">
                <div class="form-row">
                    @for (feature of featuresList | keyvalue; track feature) {
                        <div class="col-lg-3 col-md-6 col-sm-12">
                            <div class="form-group">
                                <label for="{{feature.key}}">{{words[language][feature.key]}}</label>
                                <input type="text" class="form-control form-control-sm" [value]="feature.value ? feature.value.value : ''" id="{{feature.key}}" (change)="changeFeature(feature)">
                            </div>
                        </div>
                    }
                </div>
            </div>
            <div class="modal-footer">
                <button class="btn btn-secondary mt-2 ml-2" data-dismiss="modal">Close</button>
            </div>
        </div><!-- /.modal-content -->
    </div><!-- /.modal-dialog -->
</div><!-- /.modal -->


<!-- delete modal -->
<div class="modal fade" id="deleteModal" data-backdrop="static" tabindex="-1" role="dialog"
    aria-labelledby="mySmallModalLabel">
    <div class="modal-dialog modal-sm modal-dialog-centered">
        <div class="modal-content">
            <div class="modal-body d-flex flex-wrap align-items-center justify-content-center">
                <span class="uil-trash-alt text-danger display-1"></span>
                <h3 class="text-danger w-100 text-center">{{words[language][ 'delete' ] }}</h3>
                <span class="text-dark my-1 text-center">{{words[language][ 'deleteVehicle' ] }}</span>
                <button class="btn btn-danger mt-2" (click)="deleteInventory()" [disabled]="loading">
                    @if (loading) {
                    <span class="spinner-grow spinner-grow-sm mr-1" role="status"></span>
                    }
                    {{words[language][ 'yes' ] }}</button>
                <button class="btn btn-secondary mt-2 ml-2" data-dismiss="modal">No</button>
            </div>
        </div><!-- /.modal-content -->
    </div><!-- /.modal-dialog -->
</div><!-- /.modal -->

<!-- restore modal -->
<div class="modal fade" id="restoreModal" data-backdrop="static" tabindex="-1" role="dialog"
    aria-labelledby="mySmallModalLabel">
    <div class="modal-dialog modal-sm modal-dialog-centered">
        <div class="modal-content">
            <div class="modal-body d-flex flex-wrap align-items-center justify-content-center">
                <span class="uil-redo text-warning display-1"></span>
                <h3 class="text-warning w-100 text-center">Restore</h3>
                <span class="text-dark my-1 text-center">Are you sure you want to restore this inventory?</span>
                <button class="btn btn-warning mt-2" (click)="restoreInventory()" [disabled]="loading">
                    @if (loading) {
                    <span class="spinner-grow spinner-grow-sm mr-1" role="status"></span>
                    }
                    {{words[language][ 'yes' ] }}</button>
                <button class="btn btn-secondary mt-2 ml-2" data-dismiss="modal">No</button>
            </div>
        </div><!-- /.modal-content -->
    </div><!-- /.modal-dialog -->
</div><!-- /.modal -->

<!-- change status modal -->
<div class="modal fade" id="statusModal" data-backdrop="static" tabindex="-1" role="dialog"
    aria-labelledby="mySmallModalLabel">
    <div class="modal-dialog modal-xl modal-dialog-centered">
        <div class="modal-content">
            <div class="modal-header">Status Change
                <span class="float-right clickable" data-dismiss="modal">x</span>
            </div>
            <div class="modal-body">
                <inventory-history (emitterInformation$)="listenerChildrens($event)" [language]="language"
                    [inventoryId]="inventoryId" [lotId]="lotId" [statusId]="statusId"
                    [dateOnLot]="information.get('dateOnLot').value"></inventory-history>
                <button class="btn btn-secondary mt-2 ml-2 float-right" data-dismiss="modal">Close</button>
            </div>
        </div><!-- /.modal-content -->
    </div><!-- /.modal-dialog -->
</div><!-- /.modal -->

<!-- table edit modal -->
<div class="modal fade" id="scanVIN" data-backdrop="static" tabindex="-1" role="dialog"
    aria-labelledby="mySmallModalLabel">
    <div class="modal-dialog modal-lg modal-dialog-scrollable">
        <div class="modal-content">
            <inventory-scan [language]="language" [inventoryId]="inventoryId" [calledFrom]="'inventoryDetail'"
                [lotId]="lotId" (emitterInformation$)="listenerChildrens($event)"></inventory-scan>
        </div><!-- /.modal-content -->
    </div><!-- /.modal-dialog -->
</div><!-- /.modal -->